/*globals $ */
// import "malihu-custom-scrollbar-plugin";

class BlogList {
  constructor($container) {
    this.$container = $container;
    this.$slider = this.$container.find(".sec_blog_list_area");
    this.$window = $(window);
    this.mediaQuery = window.matchMedia("(max-width: 960px)");
    this.hasScrollBar = false;
    this.scrollBarLeft = 0;
    this.spNoScroll = false;

    if (this.$container.hasClass("sp-no-scroll")) {
      this.spNoScroll = true;
    }

    if (this.$container.next().hasClass("sec_blog_scroll")) {
      this.$scrollBarContainer = this.$container.next();
      this.$scrollBar = this.$scrollBarContainer.find(".sec_blog_scroll_thumb");
      this.hasScrollBar = true;

      let onMoveScrollBar = (e) => {
        this.scrollBarLeft =
          this.startScrollBarLeft + (e.pageX - this.clickPos);
        if (this.scrollBarLeft < 0) this.scrollBarLeft = 0;
        if (this.scrollBarLeft > this.scrollBarLeftMax)
          this.scrollBarLeft = this.scrollBarLeftMax;

        this.scrollBarVal = this.scrollBarLeft / this.scrollBarLeftMax;
        this.$scrollBar.css("transform", `translateX(${this.scrollBarLeft}px)`);
        this.$container.scrollLeft(this.scrollMax * this.scrollBarVal);
      };

      let onReleaseScrollBar = (e) => {
        $(document).off("mousemove touchmove", onMoveScrollBar);
        $(document).off("mouseup touchend", onReleaseScrollBar);
      };

      this.$scrollBar.on("mousedown touchstart", (e) => {
        this.clickPos = e.pageX;
        this.clickPosDiff = e.pageX - $(e.currentTarget).position().left;
        this.startScrollBarLeft = this.scrollBarLeft;
        $(document).on("mousemove touchmove", onMoveScrollBar);
        $(document).on("mouseup touchend", onReleaseScrollBar);
      });
    }

    this.$container.on("scroll", () => {
      if (this.hasScrollBar) {
        this.scrollBarLeft =
          this.scrollBarLeftMax *
          (this.$container.scrollLeft() / this.scrollMax);
        this.$scrollBar.css("transform", `translateX(${this.scrollBarLeft}px)`);
      }
    });

    this.$window.on("resize", () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }
  onClickScrollBar(e) {
    this.clickPos = e.pageX;
    this.clickPosDiff = e.pageX - $(e.currentTarget).position().left;
    $(document).on("mousemove touchmove", this.onMoveScrollBar);
    $(document).on("mouseup touchend", this.onReleaseScrollBar);
  }

  scrollCore() {
    this.sliderWidth =
      this.itemWidth * this.$slider.find(".sec_blog_list--item").length;
    this.$slider.css("width", this.sliderWidth);
    this.scrollMax = this.sliderWidth - this.$container.width();

    if (this.hasScrollBar) {
      this.scrollBarWidth =
        this.$scrollBarContainer.width() *
        (this.$container.width() / this.sliderWidth);

      if (this.scrollBarWidth < 100) this.scrollBarWidth = 100;
      this.$scrollBar.css("width", this.scrollBarWidth);
      this.scrollBarLeftMax =
        this.$scrollBarContainer.width() - this.scrollBarWidth;
    }
  }

  onWindowResize() {
    if (this.mediaQuery.matches) {
      this.itemWidth = document.documentElement.clientWidth;
    } else {
      this.itemWidth = 380;
    }

    if (this.spNoScroll) {
      if (this.mediaQuery.matches) {
        this.$container.scrollLeft(0);
        this.$slider.css({
          "flex-direction": "column",
          width: "100%",
        });
        if (this.hasScrollBar) {
          this.$scrollBarContainer.css("display", "none");
        }
      } else {
        this.$slider.css({
          "flex-direction": "row",
        });
        if (this.hasScrollBar) {
          this.$scrollBarContainer.css("display", "block");
        }
        this.scrollCore();
      }
    } else {
      this.scrollCore();
    }
  }
}

export default BlogList;
